<app-editor
  [label]="label"
  [scope]="scope"
  [bupload]="bupload"
  [toolsType]="toolsType"
  [extraTools]="extraTools"
  [required]="required"
  [ngModel]="ngModel"
  (ngModelChange)="ngModelChange.next($event)"
>
</app-editor>
